import React, {useState} from 'react';
import {Portlet, PortletHeader} from "../../../../components/Portlet";
import CityForm from "../components/cityForm";
import {connect} from "react-redux";
import {CreateItem} from "../../../../redux/actions/base";
import {CityListRoute} from "../../../routesConstants";
import {Helmet} from "react-helmet";
import {useNavigate} from "react-router";
import axios from "../../../../helpers/axios";
import BlockUi from "@availity/block-ui";


const tempData = {
  name:'',
  nameEn:'',
  code:'',
  stateCode:'',
  country:'',
  lat:'',
  lon:''
}
const CityCreatePage = () =>{
  const [loading, setLoading] = useState()
  const navigate = useNavigate()

  const callback = (values, cb)=>{
    setLoading(true)
    axios.put('/api/locations/cities', values)
      .then(()=>navigate(CityListRoute))
      .finally(()=>setLoading(false))
  }
  return <>
    <Helmet>
      <title>Город</title>
    </Helmet>
    <BlockUi blocking={loading}>
      <CityForm onSubmit={callback} data={tempData}/>
    </BlockUi>
  </>
}

export default CityCreatePage
